/**
 * Cal.com team booking configuration.
 *
 * Round-robin distribution among the Altair Health team. Whoever is available
 * takes the call. Update CAL_TEAM_LINK if the team slug or event type slug changes.
 */

export const CAL_NAMESPACE = "altair-demo";

/** Path used by `cal("modal", { calLink })`. Format: `team/<team-slug>/<event-slug>`. */
export const CAL_TEAM_LINK = "team/altair-health/discovery-call";

/** From theme.css `--foreground: 225 45% 14%` (light mode forced on landing). */
export const CAL_BRAND_COLOR = "#141C34";
